<template>
  <div class='main'>
    <LinkTitle></LinkTitle>
    <div class="conatainer">
      <PageSearchTitle title="供应信息" hideSearch="true" :showCart="false" />
      <div class="box">
        <div v-for="(item, index) in list" :key="index" class="itemBox">
          <div class="itemBoxTitle">
            <div class="itemBoxTitleLeft">
              <span @click="()=>toGoodsDetailSupply(item,index)" class="itemBoxTitleName">
                『供应{{ formateStatus(item.sdStatus) }}』{{ item.sdName }}
              </span>
              <span class="itemBoxTitlePhone">
                联系人：{{ formateName(item.realName) }}
              </span>
                <span class="itemBoxTitlePhone">
                联系电话：{{ formatePhone(item.telphone) }}
              </span>
              <div></div>
            </div>
            <div class="publishTime">发布时间：{{item.pubTime|formateDate}}</div>
          </div>
          <div>
            <div class="itemBoxCenter">
              <el-image
                class="itemImg"
                fit='cover'
                :src="getImageUrl(item.coverPlan)"
              ></el-image>
              <div class="itemBoxCenterRight">
                <div class="itemBoxCenterRightItem price">
                  单价：{{ item.price || 0 }}元/{{item.unit}}
                </div>
                <div class="itemBoxCenterRightItem">
                  定金：{{ item.orderPrice||0 }}元/{{item.unit}}
                </div>
                <div class="itemBoxCenterRightItem cangku">
                  仓库地址：{{ item.sdAddress }}
                </div>
                <div class="itemBoxCenterRightItem">
                  产地：{{ item.birthPlace }}
                </div>
                <div class="itemBoxCenterRightItem">
                  库存：{{ item.sdNumber||0 }}{{item.buyUnit||'件'}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
      background
          @current-change="handleCurrentChange"
          :current-page.sync="(currentPage)"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="count"
        >
        </el-pagination>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { applygetListApi,getImageUrl,formateDate2 } from "@/api/api";
import PageSearchTitle from "@/components/components/PageSearchTitle";
import { mapState, mapMutations } from "vuex";
import timer from 'time-formater'
export default {
  name: "supplyPage",
  data() {
    return {
      list: null,
      count:0,
      currentPage:1,
      pageSize:15
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created(){
       this.formateDate2 = formateDate2
  },
  mounted() {
    this.getSupplyList();
    this.timer = timer
    this.getImageUrl = getImageUrl
 
  },
  components: {
    PageSearchTitle,
  },
  methods: {
    toGoodsDetailSupply(item,index){
      // alert(JSON.stringify(item))
      // return 
      this.$router.push({name:"goodsDetail",query:{
        goodsId:item.sdId,type:1,
        index
      }})
    },
    handleCurrentChange(e){
        console.log(e)
        
        this.$nextTick(()=>{
          this.getSupplyList();
        })
        
    },
    formateStatus(status) {
      if (status == 0) {
        return "";
      } else if (status == 1) {
        return "--现货";
      } else if (status == 2) {
        return "--期货";
      }
    },
    formateName(name){
    if (this.userInfo && this.userInfo.access_token) {
        return name;
      } else {
        let arr = name.split("").map((item, index) => {
          if (index>0) {
            return "*";
          } else {
            return item;
          }
        });
        return arr.join("");
      }
    },
    formatePhone(phone) {
      if (this.userInfo && this.userInfo.access_token && phone) {
        return phone;
      } else {
        let arr = phone.split("").map((item, index) => {
          if (index >= 3 && index <= 6) {
            return "*";
          } else {
            return item;
          }
        });
        return arr.join("");
      }
    },
    getSupplyList() {
      let that = this;
      let url = applygetListApi;
      let data = {
        pageIndex:this.currentPage-1,
        pageSize: this.pageSize,
        sdType: 1,
        status: 1,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            this.list = JSON.parse(JSON.stringify(data));
            this.count = res.data.count
            window.scrollTo(0, 0)
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err));
        });
    },
  },
};
</script>

<style scoped lang='less'>
.main{
  background-color: #f6f6f6
}
@media screen and(min-width:320px) and(max-width:1400px) {
  .conatainer {
    margin: 5px 10px 0 !important;
  }
}
.conatainer {
  margin: 5px 300px 0;
}
.box {
  margin-top: 20px;
  min-height: 200px;
}
.tabsBox {
}
.itemBox {
  margin-bottom: 20px;
  padding: 15px;
  // border: 1px dashed red;
  background-color: #fff;
}
.itemBoxTitle {
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}
.itemImg {
  width: 50px;
  height: 50px;
}
.itemImg:hover {
  cursor: pointer;
}
.itemBoxCenter {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}
.itemBoxCenterRight {
  flex: 1;
  margin-left: 20px;
  font-size: 13px;
  display: flex;
  flex-direction: row;
  align-content: center;
  color: #444;
}
.itemBoxCenterRightItem {
  height: 50px;
  line-height: 50px;
  margin-right: 30px;
  max-width: 20%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.itemBoxTitleName {
  color:#009e96 ;
  font-size: 18px;
  margin-left: -5px;
}
.itemBoxTitleName:hover {
  cursor: pointer;
  text-decoration: underline;
}
.price {
  color: red;
  font-size: 13px;
  font-weight: 600;
}
.cangku {
}
.publishTime {
  font-size: 13px;
  color: #aaa;
}
.itemBoxTitlePhone {
  font-size: 12px;
  color:blue;
  margin-left: 20px;
}
.itemBoxTitleLeft {
  line-height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/SupplyPage.vue